import * as React from 'react';
import { Form, Message } from 'semantic-ui-react';

export interface Datos {
    modalidad?: 'presencial' | 'online';
    modelo?: 'teens' | 'challenge' | 'discovery';
}

export const inicial: Datos = {
    modalidad: 'presencial',
    modelo: 'discovery',
};

interface Props {
    datos: Datos;
    onChange(datos: Datos): void;
}

class DatosMatriculaIngles extends React.Component<Props> {
    public render() {
        const { datos } = this.props;

        return (
            <Form.Group widths='3'>
                <Form.Field>
                    <label>Modalidad</label>
                    <Form.Radio
                        label='Presencial'
                        checked={datos.modalidad === 'presencial'}
                        onChange={() => {
                            this.onChange({ ...datos, modalidad: 'presencial' });
                        }}
                    />
                    <Form.Radio
                        label='Online'
                        checked={datos.modalidad === 'online'}
                        onChange={() => {
                            this.onChange({ ...datos, modalidad: 'online' });
                        }}
                    />

                    {!datos.modalidad && (
                        <Message color='red'>
                            No se seleccionó una modalidad para esta matrícula.
                        </Message>
                    )}
                </Form.Field>

                <Form.Field>
                    <label>Modelo de enseñanza</label>
                    <Form.Radio
                        label='Teens'
                        checked={datos.modelo === 'teens'}
                        onChange={() => {
                            this.onChange({ ...datos, modelo: 'teens' });
                        }}
                    />
                    <Form.Radio
                        label='Discovery'
                        checked={datos.modelo === 'discovery'}
                        onChange={() => {
                            this.onChange({ ...datos, modelo: 'discovery' });
                        }}
                    />
                    <Form.Radio
                        label='Challenge'
                        checked={datos.modelo === 'challenge'}
                        onChange={() => {
                            this.onChange({ ...datos, modelo: 'challenge' });
                        }}
                    />

                    {!datos.modelo && (
                        <Message color='red'>
                            No se seleccionó un modelo de enseñanza para esta matrícula.
                        </Message>
                    )}
                </Form.Field>

                <Form.Field>
                    <label>Curso</label>
                    <Form.Radio label='Asesorías' checked />
                </Form.Field>
            </Form.Group>
        );
    }

    private onChange(datos: Datos) {
        this.props.onChange({
            ...datos,
        });
    }
}

export default DatosMatriculaIngles;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S3Alumnos/componentes/Alumno/componentes/DatosMatricula/componentes/DatosMatriculaIngles.tsx